import React from "react";
import moment from "moment";

const EventInfo = (props) => {
  const startDate = moment(props.event.start_date).format("MMM Do, YYYY");
  const startTime = moment(props.event.start_date).format("h:mm a");
  const endDate = moment(props.event.end_date).format("MMM Do, YYYY");
  const endTime = moment(props.event.end_date).format("h:mm a");

  return (
    <div>
      <h3 className="event-title">Details</h3>
      <div>
        <span className="event-label">Date:</span>
        <span className="event-date">
          {" "}
          {startDate} - {endDate}
        </span>
      </div>
      <div>
        <span className="event-label">Time:</span>
        {/* NOTE: moment converts the time to the timezone on the local computer, so display that timezone */}
        <span className="event-time">
          {" "}
          {startTime} - {endTime} ({Intl.DateTimeFormat().resolvedOptions().timeZone})
        </span>
      </div>
      <span className="event-label">Location: </span>
      <span className="event-date">{props.event.location}</span>
      <br />
      <div>
        <span className="event-label">Address: </span>
        <span className="event-date">{props.event.address}</span>
      </div>
    </div>
  );
};

export default EventInfo;
